export default __webpack_public_path__ + "static/media/1.d47754d3.svg";